import BottomSection from "./BottomSection";

export default BottomSection;
